import * as React from 'react';
import { TableCellProps } from './TableProps';

type Props = TableCellProps<any, string>;

export const DateTimeCell: React.FC<Props> = ({ formattedValue }) => {
  return <span>{formattedValue}</span>;
};
